/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pm_TitleInputs */

const cs_pm_title = /** @type {(inputs: Pm_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mapování ID inzerátů na portálech`)
};

const en_pm_title = /** @type {(inputs: Pm_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Portal listing ID mapping`)
};

/**
* | output |
* | --- |
* | "Portal listing ID mapping" |
*
* @param {Pm_TitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const pm_title = /** @type {((inputs?: Pm_TitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pm_TitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pm_title(inputs)
	return cs_pm_title(inputs)
});